'use client';

import { useMutation } from '@tanstack/react-query';
import { passwordService } from '../services/passwordService';
import type {
	IOtpVerification,
	IPasswordChange,
	IPasswordForgot,
	IPasswordReset,
} from '../types/auth';

export const usePassword = () => {
	const changePasswordMutation = useMutation({
		mutationFn: (data: IPasswordChange) => passwordService.changePassword(data),
	});

	const resetPasswordMutation = useMutation({
		mutationFn: (data: IPasswordReset) => passwordService.resetPassword(data),
	});

	const forgotPasswordMutation = useMutation({
		mutationFn: (data: IPasswordForgot) => passwordService.forgotPassword(data),
	});

	const verifyOtpMutation = useMutation({
		mutationFn: (data: IOtpVerification) => passwordService.verifyOtp(data),
	});

	return {
		changePassword: changePasswordMutation.mutate,
		resetPassword: resetPasswordMutation.mutate,
		forgotPassword: forgotPasswordMutation.mutate,
		verifyOtp: verifyOtpMutation.mutate,
		isLoading:
			changePasswordMutation.isPending ||
			resetPasswordMutation.isPending ||
			forgotPasswordMutation.isPending ||
			verifyOtpMutation.isPending,
		error:
			changePasswordMutation.error ||
			resetPasswordMutation.error ||
			forgotPasswordMutation.error ||
			verifyOtpMutation.error,
	};
};
